/**
 * Number formatting and dial-input normalisation (libphonenumber-js/min, default region AU).
 */
import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

/** `0412345678` -> `0412 345 678`; `+14155550100` -> `+1 415 555 0100`; anything else as typed */
export function formatAuNumber(raw: string | null | undefined): string {
  if (!raw) return '';
  const cleaned = raw.trim();
  if (cleaned.length === 0) return '';
  const pn = parsePhoneNumberFromString(cleaned, 'AU');
  if (!pn || !pn.isPossible()) return cleaned;
  return pn.country === 'AU' ? pn.formatNational() : pn.formatInternational();
}

/** strip visual separators; keep a leading + and the DTMF-ish characters an extension may use */
export function normaliseDialInput(raw: string): string {
  const t = raw.trim().replace(/[\s().-]/g, '');
  if (t.startsWith('+')) return `+${t.slice(1).replace(/[^0-9]/g, '')}`;
  return t.replace(/[^0-9*#]/g, '');
}

/** E.164 for the relay `dial` command when the input parses, else the normalised digits */
export function toDialTarget(raw: string): string | null {
  const n = normaliseDialInput(raw);
  if (n.length === 0) return null;
  const pn = parsePhoneNumberFromString(n, 'AU');
  if (pn && pn.isPossible()) return pn.number;
  return n;
}

/** `tel:+61412345678` or `tel:0412%20345%20678` -> the number; null when not a tel URI */
export function telUriToNumber(uri: string): string | null {
  const m = /^tel:(.+)$/i.exec(uri.trim());
  if (!m) return null;
  let v = m[1] ?? '';
  try {
    v = decodeURIComponent(v);
  } catch {
    /* keep raw */
  }
  const semi = v.indexOf(';');
  if (semi >= 0) v = v.slice(0, semi);
  const n = normaliseDialInput(v);
  return n.length > 0 ? n : null;
}

/** last three digits only (CONVENTIONS rule 11) for logs */
export { maskNumber } from '@ccphone/contracts';
